var map = {
	"./Adam_Seidman_Resume.pdf": 26,
	"./Adam_Seidman_Resume_2022.pdf": 27,
	"./IndieFlower-Regular.ttf": 28,
	"./VarelaRound-Regular.ttf": 29,
	"./adam_seidman.jpg": 5,
	"./baja_logo.png": 30,
	"./bluetooth.png": 31,
	"./checker-board.png": 32,
	"./cloud_18_logo.png": 33,
	"./dsf_elogo.png": 34,
	"./dsf_logo.png": 35,
	"./e-magnet.png": 36,
	"./gear_pic.png": 37,
	"./generator.png": 38,
	"./grayscale.png": 39,
	"./line-follow.png": 40,
	"./money.png": 41,
	"./multi-cpu.png": 42,
	"./rpi.png": 43,
	"./shifter.png": 44,
	"./shock-absorber.png": 45,
	"./shot_trainer.png": 46,
	"./vuejs.png": 47,
	"./wordle.png": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;